import { render, staticRenderFns } from "./classify-table.vue?vue&type=template&id=d267eba0&"
import script from "./classify-table.vue?vue&type=script&lang=js&"
export * from "./classify-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports